import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { dateToText } from '../components/application/global.function';
import aggrQueryParams from '../helpers/aggrQueryParams';
import {
    IHistoryEventList,
    IHistoryEvents,
    IHistoryEventsFilterParams,
    IHistoryFilterItem,
    IHistoryItemHtmlList,
} from '../interfaces/history.interfaces';
import { ILabSize } from '../interfaces/lab.interfaces';
import { IService, IServiceSize } from '../interfaces/services.interfaces';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class HistoryService {
    public constructor(
        private httpNew: HttpNewService,
        private auth: AuthService,
    ) {}

    /**
     * Количество истории (Visit Diag)
     * @param parameters
     */
    public getHistoryEventsSize(params: {
        beginDate: Date | null;
        endDate: Date | null;
        specId: number | null;
        docId: number | null;
        depId: number | null;
    }): Observable<ILabSize> {
        let url = '/history/events/size';

        const queryParams = aggrQueryParams(params);

        if (params.beginDate)
            queryParams.beginDate = dateToText(params.beginDate);
        if (params.endDate) queryParams.endDate = dateToText(params.endDate);

        return this.httpNew.get<ILabSize>(url, queryParams);
    }

    public getHistoryEventsFilter(
        params: IHistoryEventsFilterParams,
    ): Observable<Array<IHistoryFilterItem>> {
        const url = `/history/events/filters`;
        const queryParams = aggrQueryParams(params);
        return this.httpNew.get<Array<IHistoryFilterItem>>(url, queryParams);
    }

    /**
     * Список истории (Visit Diag)
     * @param parameters
     */
    public getHistoryEvents(
        beginDate: Date | null,
        endDate: Date | null,
        start?: number,
        end?: number,
        specId?: number | null,
        docId?: number | null,
        depId?: number | null,
    ): Observable<Array<IHistoryEvents>> {
        let url = '/history/events';

        const queryParams = aggrQueryParams({
            beginDate,
            endDate,
            start,
            end,
            specId,
            docId,
            depId,
        });

        if (beginDate) queryParams.beginDate = dateToText(beginDate);
        queryParams.endDate = dateToText(endDate || new Date());
        return this.httpNew.get<Array<IHistoryEvents>>(url, queryParams);
    }

    // Ира: походу устаревшее и не используется, комменчу
    // /**
    //  * Список истории за указанный промежуток времени
    //  * @param parameters
    //  * @returns {Observable<IHistoryEventList[]>}
    //  */
    // public getHistoryEventList(parameters: {
    //     begin: string;
    //     end: string;
    // }): Observable<IHistoryEventList[]> {
    //     const { begin, end } = parameters;
    //     const url =
    //         '/api/patient/' +
    //         null +
    //         '/history/event?beginDate=' +
    //         begin +
    //         '&endDate=' +
    //         end;
    //     return this.httpNew.get(url);
    // }

    /**
     * Получить событие по его типу и идентификатору
     * @param parameters
     * @returns {Observable<IHistoryVisit[] | IHistoryDiag[]>}
     */
    public getHistoryItem(parameters: {
        id: number;
        typeHistory: string;
    }): Observable<Array<IHistoryItemHtmlList>> {
        const url = `/history/events/item?typeRes=${parameters.typeHistory}&id=${parameters.id}`;
        return this.httpNew.get<Array<IHistoryItemHtmlList>>(url);
    }

    /**
     * Получить список услуг
     */

    public getServices(
        beginDate: Date | null,
        endDate: Date | null,
        pStart?: number,
        pEnd?: number,
    ): Observable<Array<IService>> {
        const param = new Array();

        if (beginDate) {
            param.push('beginDate=' + dateToText(new Date(beginDate)));
        }

        if (endDate) {
            param.push('endDate=' + dateToText(new Date(endDate)));
        }
        if (pStart && pEnd) {
            param.push('start=' + pStart);
            param.push('end=' + pEnd);
        }

        const pr = param.join('&');
        const url = '/service/patient?' + pr;
        return this.httpNew.get<Array<IService>>(url);
    }

    /**
     * Получить список услуг - количество записей
     */

    public getServicesSize(
        beginDate: Date | null,
        endDate: Date | null,
    ): Observable<IServiceSize> {
        const param = new Array();

        if (beginDate) {
            param.push('beginDate=' + dateToText(new Date(beginDate)));
        }

        if (endDate) {
            param.push('endDate=' + dateToText(new Date(endDate)));
        }

        const pr = param.join('&');
        const url = '/service/patient/size?' + pr;
        return this.httpNew.get<IServiceSize>(url);
    }

    /**
     * Получить pdf из внешней системы
     * @returns {Observable<IHistoryVisit[] | IHistoryDiag[]>}
     */
    public getApiPdf(link: string): Observable<
        | string
        | {
              message: string;
              code: string;
              config: any;
              name: string;
              stack: string;
              status: number;
          }
    > {
        const url = '/history/events/visit/api';
        return this.httpNew.post<
            | string
            | {
                  message: string;
                  code: string;
                  config: any;
                  name: string;
                  stack: string;
                  status: number;
              }
        >(url, { url: link }, true);
    }
}
